module.exports = __webpack_public_path__ + "assets/img/customerServiceBot-banner.dccf3c4b.png";